import { userPurchaseOrdersPath } from "~/routes";
import { createSearchListStore } from "./create-search-list-store";

export const usePurchaseOrderSearchStore = createSearchListStore({
  id: "purchaseOrderSearch",
  path: userPurchaseOrdersPath,
  itemsKey: "orders",
  filters: [
    { key: "q", type: "string" },
    { key: "states", type: "stringArray", persist: true },
    { key: "supplierIds", type: "idArray", persist: true },
    { key: "transporterIds", type: "idArray", persist: true },
    { key: "beginDate", type: "date" },
    { key: "endDate", type: "date" },
    { key: "receivedBeginDate", type: "date" },
    { key: "receivedEndDate", type: "date" },
  ],
});
